import z from 'zod'

import {
	scenarioBusinessSchema,
	scenarioStopListSchema,
	scenarioStrategySchema,
} from '@/entities/scenario'

import { filterSchema } from '@/shared/components/filter/validation'

export const optimizationGroupFormSchema = z.object({
	name: z.string(),
	description: z.string(),
	sales_entities: z.array(z.string()),
	product_groups: z.array(
		z.object({
			product_group_id: z.string(),
			filters: z.array(filterSchema).nullable(),
		})
	),
	optimization_group_id: z.string(),
	stop_list: scenarioStopListSchema,
	business: scenarioBusinessSchema,
	strategy: scenarioStrategySchema,
})
